export default {
  title: 'RSVP OPT-IN SETTINGS',
  items: {
    SharedConversionEnabled: {
      label: 'Shared Conversion Enabled',
      type: 'boolean'
    },
    SharedConversionMinutes: {
      label: 'Shared Conversion Minutes',
      type: 'integer',
      unit: 'minutes'
    },
    OptinAirportStart: {
      label: 'Airport Pickup - Start Time',
      type: 'string',
      unit: 'time (e.g. 8:00am)'
    },
    OptinAirportEnd: {
      label: 'Airport Pickup - End Time',
      type: 'string',
      unit: 'time (e.g. 11:00pm)'
    },
    OptinCombineAirportPickup: {
      label: 'Enable Airport Pickup from Auto Package',
      type: 'boolean'
    },
    OptinCombineAirportDropoff: {
      label: 'Enable Airport Dropoff from Auto Package',
      type: 'boolean'
    },
    OptinMaxRsvpPerPackage: {
      label: 'RSVP Count Per Package',
      type: 'integer',
      unit: 'RSVP'
    },
    OptinDirectionAngle: {
      label: 'Maximum Bearing',
      type: 'integer',
      unit: 'degress (0-360)'
    },
    OptinDirectionDistance: {
      label: 'Max Distance from Pickup and Dropoff',
      type: 'integer',
      unit: 'miles (1-999)'
    },
    OptinMaxThresholdTime: {
      label: 'RSVP Inclusion Window',
      type: 'integer',
      unit: 'minutes'
    },
    OptinMaxPickupThresholdTime: {
      label: 'Pickup Time Adjustment Window',
      type: 'integer',
      unit: 'minutes'
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/rsvp-optin-settings.js